export const SORT_TYPES = {
  ASC: 'ASC',
  DESC: 'DESC'
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Table/constants.js